/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Rest_BodyInputs */

const en_us2_offline_rest_body = /** @type {(inputs: Offline_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time for your next set.`)
};

const pt_br2_offline_rest_body = /** @type {(inputs: Offline_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora da próxima série.`)
};

const es_419_offline_rest_body = /** @type {(inputs: Offline_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de tu siguiente serie.`)
};

const pt_pt2_offline_rest_body = /** @type {(inputs: Offline_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora da próxima série.`)
};

const fr_fr2_offline_rest_body = /** @type {(inputs: Offline_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est l'heure de ta prochaine série.`)
};

const de_de2_offline_rest_body = /** @type {(inputs: Offline_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit für deinen nächsten Satz.`)
};

const it_it2_offline_rest_body = /** @type {(inputs: Offline_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ora la prossima serie.`)
};

/**
* | output |
* | --- |
* | "Time for your next set." |
*
* @param {Offline_Rest_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_rest_body = /** @type {((inputs?: Offline_Rest_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Rest_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_rest_body(inputs)
	if (locale === "es-419") return es_419_offline_rest_body(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_rest_body(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_rest_body(inputs)
	if (locale === "de-DE") return de_de2_offline_rest_body(inputs)
	if (locale === "it-IT") return it_it2_offline_rest_body(inputs)
	return en_us2_offline_rest_body(inputs)
});
export { offline_rest_body as "offline.rest_body" }